'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    NavCategoryProvider: function() {
        return NavCategoryProvider;
    },
    useNavCategoryContext_unstable: function() {
        return useNavCategoryContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const NavCategoryContext = /*#__PURE__*/ _react.createContext(undefined);
const navCategoryContextDefaultValue = {
    open: false,
    value: ''
};
const { Provider: NavCategoryProvider } = NavCategoryContext;
const useNavCategoryContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(NavCategoryContext)) !== null && _React_useContext !== void 0 ? _React_useContext : navCategoryContextDefaultValue;
};
